"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var React = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _ThemeProvider = require("../../theme/ThemeProvider");

var _style = _interopRequireDefault(require("./style"));

var useStyles = (0, _ThemeProvider.createUseStyles)(_style["default"]);

var Box = function Box(_ref) {
  var _ref$kind = _ref.kind,
      kind = _ref$kind === void 0 ? 'Default' : _ref$kind,
      children = _ref.children,
      className = _ref.className,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["kind", "children", "className"]);
  var classes = useStyles();
  return /*#__PURE__*/React.createElement("div", (0, _extends2["default"])({
    className: (0, _classnames["default"])(classes.InfoBox, classes["Kind".concat(kind)], className)
  }, props), children);
};

exports["default"] = Box;

function createInfoBox(kind) {
  return function BoxWithKind(props) {
    return /*#__PURE__*/React.createElement(Box, (0, _extends2["default"])({}, props, {
      kind: kind
    }));
  };
}
/**
 * The green button component
 */


Box.Positive = createInfoBox('Positive');
//# sourceMappingURL=index.js.map